export enum WalletStatus {
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	REVERTED = 'REVERTED',
	PENDING_APPROVAL = 'PENDING_APPROVAL',
	CANCELLED = 'CANCELLED',
}
